export default __webpack_public_path__ + "static/media/pa.b6cef8a5.mp3";